import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Input as AntdInput } from 'antd';
import { Body4 } from '../../../../ui';
import { Label } from '../Label';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { getLocalizedText } from '../../../../utils/helpers';
import { useTranslation } from 'react-i18next';

export const Input = forwardRef(
  (
    {
      disabled = false,
      tooltip,
      tooltip_RU,
      tooltip_LV,
      status,
      successMessage = 'Success message',
      onChange,
      iconAfter,
      password = false,
      value,
      label,
      icon,
      required,
      isRequired,
      textTransform = null,
      error,
      maxLength,
      clearRegex = null,
      marginTopLabel,
      suffix,
      type,
      wide,
      layout,
      boldLabel,
      ...props
    },
    ref
  ) => {
    const { i18n } = useTranslation();

    const onClearField = (e) => {
      if (clearRegex) e.target.value = e.target.value.replace(clearRegex, '');
    };

    return (
      <>
        <Label
          required={isRequired || required}
          label={label}
          tooltip={
            tooltip
              ? getLocalizedText(
                  {
                    tooltip: tooltip,
                    tooltip_RU: tooltip_RU,
                    tooltip_LV: tooltip_LV
                  },
                  'tooltip',
                  i18n
                )
              : null
          }
          marginTop={marginTopLabel}
          layout={layout}
          wide={wide}
          bold={boldLabel}
        >
          {password === false ? (
            <StyledAntdInput
              type={type}
              maxLength={maxLength}
              ref={ref}
              onInput={clearRegex ? onClearField : null}
              onChange={onChange}
              placeholder={label}
              disabled={disabled}
              status={status}
              suffix={suffix}
              value={value}
              $status={status}
              $wide={wide}
              {...props}
            />
          ) : (
            <StyledAntdPasswordInput
              type={type}
              maxLength={maxLength}
              ref={ref}
              value={value}
              onChange={onChange}
              placeholder={label}
              disabled={disabled}
              status={status}
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
              $status={status}
              $password={true}
              {...props}
            />
          )}
        </Label>

        {error && (
          <Body4 $marginTop={8} $color={'#FF424F'}>
            {error}
          </Body4>
        )}

        {status === 'success' && (
          <Body4 $marginTop={8} $color={'#00AB56'}>
            {successMessage}
          </Body4>
        )}
      </>
    );
  }
);

const StyledAntdInput = styled(AntdInput)`
  padding: ${({ $status }) =>
    $status === 'error' || $status === 'success' ? '8px 8px 8px 16px' : '9.5px 8px 9.5px 16px'};
  height: 40px !important;
  font-size: 14px;
  color: #27272a;
  border-color: #dddde3;
  border-radius: 4px;
  &:hover {
    border-color: #006fff;
  }
  &.ant-input:placeholder-shown {
    color: #808089;
  }
  ${({ $status }) => ($status === 'success' ? 'border-color: #00AB56' : '')}
  ${({ $wide }) => ($wide ? 'width: 100%' : '')}
`;

const StyledAntdPasswordInput = styled(StyledAntdInput.Password)`
  padding: ${({ $status, $password }) =>
    $status === 'error' || $status === 'success' || $password === true
      ? '8px 8px 8px 16px'
      : '9.5px 8px 9.5px 16px'};
  height: 40px !important;
  font-size: 14px;
  color: #27272a;
  border-color: #dddde3;
  border-radius: 4px;
  &:hover {
    border-color: #006fff;
  }
  &.ant-input:placeholder-shown {
    color: #808089;
  }
  ${({ $status }) => ($status === 'success' ? 'border-color: #00AB56' : '')}
`;
